export class ProfileMembershipInformationMin {
  public ProfileId: number;
  public MembershipLevelId: number;
  public MemberSince: Date;
  public MemberSource: string;
  public Member: boolean;
  public MemberNotes: string;

  constructor() {
    this.ProfileId = 0;
    this.MembershipLevelId = 0;
    this.MemberSince = new Date();
    this.MemberSource = '';
    this.Member = false;
    this.MemberNotes = '';
  }
}
